/* Impression SCDM — LES LIMITES DE DIMENSION.

   ============================================================================
   POURQUOI CE FICHIER EXISTE
   ============================================================================
   Audit du 6 septembre 2026. On a demande au configurateur une piece de
   200 x 200 po. Il a repondu : 3 351 $, prix ferme, bouton d achat actif.
   C est 278 pi2 de vinyle en un seul morceau, sur une laize utile de 52 po de
   large. Personne ne pouvait fabriquer ca, et le client pouvait le payer.

   Le bouton « BLOQUE » qu on voit parfois n etait PAS une protection : c est le
   garde-fou de demarrage a vide (classe scdm-attente), qui tombe des qu un
   fichier est charge. Verifie en testant un 4 po dans le meme etat — meme
   bouton, meme classe.

   Il n y avait donc AUCUNE borne haute. Ce fichier la pose.

   ============================================================================
   LES TROIS ZONES
   ============================================================================
   VERT — prix ferme immediat.
       Petit cote <= 52 po, grand cote <= 60 po, et la surface reste dans la
       grille. Une passe machine, un colis que les transporteurs acceptent.

   JAUNE — prix ferme, mais expedition sur devis.
       Grand cote entre 60 et 240 po. La piece se fabrique sans probleme ; c est
       le transport qui coince. Aucun transporteur de colis ne prend plus de
       60 po : ca part en transport routier, et le tarif ne se calcule pas
       d avance. Le prix du produit, lui, reste ferme. La mention part sur la
       commande, pour que l atelier sache qu il doit chiffrer le transport.

   ROUGE — soumission obligatoire, le bouton d achat est bloque.
       Quatre causes, chacune reelle. La quatrieme n est PAS un refus : voir
       la note de CANNELE_QTE_MAX plus bas. Elle porte la classe « offre »,
       elle est la seule a poser « sansPrix », et c est elle qui fait taire
       l affichage du prix dans scdm-prix-direct.js.
       1. Petit cote > 52 po. La largeur utile d impression est de 52 po. Au
          dela, il faut fractionner l image et raccorder les les a la pose :
          c est un travail sur mesure, pas une case de grille.
       2. Grand cote > 240 po (20 pi). Au dela, c est un chantier de pose, pas
          une commande en ligne.
       3. Plus de 1 296 po2 SANS support rigide. La grille des autocollants
          s arrete a 36 po de cote (1 296 po2) : au dela, scdm.js extrapole, et
          une extrapolation n est pas un prix. Avec un support rigide, la
          contrainte disparait : le prix des pancartes est une formule
          (mise en route + surface x taux), valable a n importe quelle taille.
       4. Plus de 25 exemplaires sur PLASTIQUE CANNELE. Notre procede — un
          vinyle imprime pose sur le panneau — ne se rattrape pas au volume ;
          il se rattrape par le regroupement, qui se chiffre a la main. En
          deca de 25 exemplaires, aucun prix ne bouge.

   ============================================================================
   COMMENT LE BLOCAGE TIENT
   ============================================================================
   scdm.js reconstruit ses rangees a chaque redessin : une propriete disabled
   posee une fois serait effacee a la premiere frappe du client. On fait donc
   deux choses, et les deux sont necessaires :

   1. UN ECOUTEUR DE CLIC SUR LE DOCUMENT, EN CAPTURE. Il s execute avant tous
      les ecouteurs poses sur le bouton lui-meme — celui de scdm.js comme celui
      de scdm-panneau.js. En zone rouge il coupe net : rien n est ajoute.
      C est ca, la vraie protection. Le reste n est que de l affichage.

   2. UN RAFRAICHISSEMENT PERIODIQUE de l apparence du bouton et du message.
      Meme cadence que scdm-panneau.js (400 ms), pour la meme raison.

   Charge depuis snippets/scdm-minimum.liquid, en defer, apres scdm-panneau.js.
   Sans ce fichier, le configurateur revend un 200 x 200 po.

   ============================================================================
   LES DEUX UNITES DANS LES MESSAGES — 11 septembre 2026
   ============================================================================
   Decision du proprietaire : tout chiffre montre au client porte les POUCES
   ET les MILLIMETRES. 1 po = 25,4 mm exactement. Les bornes ci-dessous restent
   en pouces et AUCUN calcul n a change : seul le texte affiche gagne la
   deuxieme unite, par enMm(), qui existait deja pour la soumission. */

(function () {
  'use strict';

  /* ------------------------------------------------------------- reglages */

  /* Largeur utile d impression : 52 po. Decision du proprietaire du
     11 septembre 2026 — la borne est a 52 po PARTOUT. Elle valait 50 ici
     pendant que assets/scdm-custom.js annoncait deja 52 : le client qui
     demandait 51 po voyait un prix s afficher, puis se faisait refuser au
     panier. Une seule valeur maintenant, dans les deux fichiers. */
  var MAX_PETIT = 52;

  /* 20 pi. Au dela, la piece ne se manipule plus seul a l atelier. */
  var MAX_GRAND = 240;

  /* Au dela, aucun transporteur de colis n accepte le paquet. */
  var SEUIL_COLIS = 60;

  /* Derniere ligne de la grille des autocollants : 36 po de cote. */
  var AIRE_MAX_SOUPLE = 1296;

  /* =====================================================================
     LE PLASTIQUE CANNELE AU-DELA DE 25 EXEMPLAIRES — 11 septembre 2026

     DECISION DU PROPRIETAIRE. Releve de marche du 11 septembre, pancarte
     de 18 x 24 po sur plastique cannele :

       a l unite        nous sommes au 80e centile  -> dans le marche
       a 10 exemplaires nous sommes au 75e centile  -> dans le marche
       a 100 exemplaires  12,92 $ contre 5,15 / 5,99 / 12,70 $
                                                    -> les plus chers du lot

     L ecart ne vient pas de la marge, il vient du PROCEDE : les autres
     impriment directement sur le panneau, nous posons un vinyle imprime.
     Notre facon de faire ne se rattrape pas au volume ; elle se rattrape par
     le REGROUPEMENT — plusieurs travaux sur la meme feuille, la meme passe,
     la meme mise en route. Ca, ca se chiffre a la main, pas dans une grille.

     EN DECA DE 25, ON NE TOUCHE A RIEN : les prix restent exactement ceux
     d aujourd hui, au cent pres. Au-dela, le prix cesse de s afficher et le
     client part vers la soumission, avec sa configuration deja remplie.

     POUR DEPLACER LE SEUIL : le nombre ci-dessous, et lui seul.
     ===================================================================== */
  var CANNELE_QTE_MAX = 25;
  var CANNELE_SUPPORT = 'coroplast';

  var PAGE_SOUMISSION = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'pages/soumission';

  /* La meme cle que scdm-panier-technique.js depose et relit sur
     /pages/soumission. On n en invente pas une deuxieme : c est deja le
     chemin par lequel une commande hors grille arrive au formulaire. */
  var CLE_SOUMISSION = 'scdmSoumissionAuto';

  /* ---------------------------------------------------------------- l etat */

  var boite = null;
  var dernierRendu = '';
  var etatCourant = 'vert';

  function S() { return window.SCDM; }
  function D() { return window.SCDM_DATA; }

  function texteLimite(cle, defaut) {
    var racine = document.getElementById('scdmLimitesI18n');
    var traduit = racine && racine.getAttribute('data-limit-' + cle);
    return traduit && traduit.trim() ? traduit : defaut;
  }

  function renduLimiteAnglais(cle, v) {
    if (!/^en(?:-|$)/i.test(document.documentElement.lang || '')) return null;
    var modele = texteLimite(cle, '');
    if (!modele) return null;
    var c = v.cotes || {};
    var valeurs = { limit: CANNELE_QTE_MAX, quantity: v.qte || quantite() };
    if (c.petit !== undefined) valeurs.small = nb(c.petit).replace(',', '.') + ' in (' + enMm(c.petit) + ' mm)';
    if (c.grand !== undefined) valeurs.long = nb(c.grand).replace(',', '.') + ' in (' + enMm(c.grand) + ' mm)';
    if (c.aire !== undefined) valeurs.area = nb(c.aire / 144).replace(',', '.');
    valeurs.url = PAGE_SOUMISSION;
    return modele.replace(/\{(limit|quantity|small|long|area|url)\}/g, function (_, nom) {
      return String(valeurs[nom] === undefined ? '' : valeurs[nom]).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    });
  }

  /* ------------------------------------------------------------------ style */

  function style() {
    if (document.getElementById('scdmLimitesStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmLimitesStyle';
    s.textContent = [
      '.scdm-limite{margin:0 0 12px;padding:12px 14px;border-radius:10px;',
      'font-size:12.5px;line-height:1.55;border:1px solid transparent}',
      '.scdm-limite[hidden]{display:none !important}',
      '.scdm-limite .li-t{display:block;margin:0 0 5px;font-size:13px;font-weight:600}',
      '.scdm-limite p{margin:0 0 7px}',
      '.scdm-limite p:last-child{margin:0}',
      '.scdm-limite b{font-weight:600}',
      '.scdm-limite a{font-weight:600;text-decoration:underline}',

      /* ROUGE — soumission obligatoire */
      '.scdm-limite.rouge{border-color:#7A3038;background:#2A1519;color:#F0C9CE}',
      '.scdm-limite.rouge .li-t{color:#FF9AA5}',
      '.scdm-limite.rouge b{color:#FFE3E6}',
      '.scdm-limite.rouge a{color:#FF9AA5}',
      'html.scdm-jour .scdm-limite.rouge{background:#FDECEE;border-color:#E4AEB5;color:#5C2A31}',
      'html.scdm-jour .scdm-limite.rouge .li-t{color:#96222F}',
      'html.scdm-jour .scdm-limite.rouge b{color:#3A161B}',
      'html.scdm-jour .scdm-limite.rouge a{color:#96222F}',

      /* JAUNE — expedition sur devis */
      '.scdm-limite.jaune{border-color:#6E5A2A;background:#221C10;color:#E4D3A8}',
      '.scdm-limite.jaune .li-t{color:#E8C066}',
      '.scdm-limite.jaune b{color:#F5EBD2}',
      'html.scdm-jour .scdm-limite.jaune{background:#FBF3E0;border-color:#DEC591;color:#54431C}',
      'html.scdm-jour .scdm-limite.jaune .li-t{color:#8A6410}',
      'html.scdm-jour .scdm-limite.jaune b{color:#3A2D0F}',

      /* L OFFRE — meme blocage du bouton, mais ce n est pas un refus.
         Le cannele en volume n a rien d impossible : c est une invitation a
         se faire faire un prix. Un encadre rouge dirait le contraire de la
         phrase qu il contient, alors il porte la couleur d accent du site. */
      '.scdm-limite.rouge.offre{border-color:#A85A16;background:#231708;color:#F0D9BE}',
      '.scdm-limite.rouge.offre .li-t{color:#FFB35C}',
      '.scdm-limite.rouge.offre b{color:#FFEBD6}',
      '.scdm-limite.rouge.offre a{color:#FFB35C}',
      'html.scdm-jour .scdm-limite.rouge.offre{background:#FFF4E8;border-color:#EBC79C;color:#5A3A14}',
      'html.scdm-jour .scdm-limite.rouge.offre .li-t{color:#9A5410}',
      'html.scdm-jour .scdm-limite.rouge.offre b{color:#3A2409}',
      'html.scdm-jour .scdm-limite.rouge.offre a{color:#9A5410}',

      /* Le bouton qui emmene a la soumission deja remplie */
      '.scdm-limite .li-b{display:inline-block;margin:4px 0 0;padding:10px 18px;',
      'border:0;border-radius:9px;background:#FF7A18;color:#2A1607;',
      'font:inherit;font-size:13.5px;font-weight:700;cursor:pointer;line-height:1.2}',
      '.scdm-limite .li-b:hover{filter:brightness(1.08)}',
      '.scdm-limite .li-b:focus-visible{outline:2px solid currentColor;outline-offset:2px}',

      /* Le bouton, quand il est bloque */
      '#scdmAjouter.scdm-hors-limite{opacity:.42;cursor:not-allowed;filter:grayscale(.6)}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------- les outils */

  function nb(v) { return v.toFixed(1).replace('.', ',').replace(/,0$/, ''); }

  /* Les cotes en POUCES. scdm.js garde toujours etat.larg / etat.haut en
     pouces — le choix mm/cm ne change que l affichage. Meme lecture que
     scdm-panneau.js : si les deux cotes ne redonnent pas l aire, on retombe
     sur un carre de meme surface. */
  function cotes() {
    var s = S();
    var e = s && s.etat;
    if (!e || !s.calcul) return null;
    var c = s.calcul();
    var a = c ? c.aire : 0;
    if (!(a > 0)) return null;
    var l = Number(e.larg) || 0, h = Number(e.haut) || 0;
    if (!(l > 0 && h > 0) || Math.abs(l * h - a) > 0.5) l = h = Math.sqrt(a);
    return { petit: Math.min(l, h), grand: Math.max(l, h), aire: l * h };
  }

  /* Un support rigide est-il choisi ? scdm-panneau.js le marque sur le bouton
     retenu de sa rangee. Absence de rangee = pas de support. */
  function supportChoisi() {
    var r = document.getElementById('scdmSupports');
    if (!r) return '';
    var on = r.querySelector('button.opt.on[data-support]');
    return (on && on.getAttribute('data-support')) || '';
  }

  function supportRigide() {
    var id = supportChoisi();
    return !!(id && id !== 'aucun');
  }

  /* La quantite RETENUE par le calcul, pas celle tapee au clavier : scdm.js
     la borne entre QTE_MIN et QTE_MAX, et c est la version bornee qui est
     facturee. Comparer le seuil a autre chose serait comparer a un chiffre
     que personne ne paie. */
  function quantite() {
    var s = S();
    if (!s || typeof s.calcul !== 'function') return 0;
    var c = s.calcul();
    return (c && Number(c.qte)) || 0;
  }

  /* Le libelle d une valeur, tire de scdm-data.js. Jamais une chaine ecrite
     ici : le jour ou le proprietaire renomme une matiere, la soumission la
     renomme avec lui. */
  function libelle(liste, val) {
    var l = (D() && D()[liste]) || [];
    for (var i = 0; i < l.length; i++) if (l[i].id === val) return l[i].label;
    return '';
  }

  /* ------------------------------------------------------------- LE VERDICT */

  function verdict() {
    var c = cotes();
    if (!c) return { zone: 'vert', cotes: null };

    var demande = window.SCDM_SUPPORT_DEMANDE ? window.SCDM_SUPPORT_DEMANDE() : {};
    if (c.grand > 36) return { zone: 'rouge', cotes: c, motif: 'grand36', sansPrix: true };
    if (demande.surMesure) return { zone: 'rouge', cotes: c, motif: 'surmesure', sansPrix: true };
    if (demande.routier && quantite() >= 10) return { zone: 'rouge', cotes: c, motif: 'route10', qte: quantite(), sansPrix: true };
    if (c.petit > MAX_PETIT) {
      return { zone: 'rouge', cotes: c, motif: 'petit' };
    }
    if (c.grand > MAX_GRAND) {
      return { zone: 'rouge', cotes: c, motif: 'grand' };
    }
    if (c.aire > AIRE_MAX_SOUPLE && !supportRigide()) {
      return { zone: 'rouge', cotes: c, motif: 'surface' };
    }
    /* LE CANNELE EN VOLUME. En dernier parmi les causes rouges : une piece
       qui sort deja des dimensions possibles doit s entendre dire CA
       d abord — c est la contrainte la plus forte. Ici, rien n est
       impossible, c est le prix automatique qui n a plus rien a dire.
       « sansPrix » est ce que scdm-prix-direct.js lit pour se taire. */
    var q = quantite();
    if (supportChoisi() === CANNELE_SUPPORT && q > CANNELE_QTE_MAX) {
      return { zone: 'rouge', cotes: c, motif: 'cannele', qte: q, sansPrix: true };
    }
    if (c.grand > SEUIL_COLIS) {
      return { zone: 'jaune', cotes: c };
    }
    return { zone: 'vert', cotes: c };
  }

  /* --------------------------------------------------------------- LE RENDU */

  function poser() {
    if (boite && document.body.contains(boite)) return true;
    var b = document.getElementById('scdmAjouter');
    if (!b || !b.parentNode) return false;
    /* LA BOITE EST NEUVE, DONC VIDE : le souvenir du dernier rendu ne vaut
       plus rien. Sans cette ligne, peindre() comparait le texte rouge a
       celui qu il avait ecrit dans la boite PRECEDENTE, concluait « rien n a
       change » et laissait la boite neuve vide et masquee — le blocage
       tenait, le message ne s affichait plus. Bouton muet. */
    dernierRendu = '';
    boite = document.createElement('div');
    boite.className = 'scdm-limite';
    boite.id = 'scdmLimite';
    boite.hidden = true;
    boite.setAttribute('role', 'status');
    b.parentNode.insertBefore(boite, b);
    return true;
  }

  /* =====================================================================
     LA SOUMISSION DEJA REMPLIE

     On ne bricole pas un deuxieme chemin : scdm-panier-technique.js depose
     deja un paquet dans sessionStorage sous « scdmSoumissionAuto », et c est
     lui qui le relit sur /pages/soumission pour remplir le formulaire. On
     ecrit le meme paquet, avec les memes cles, plus « matiereMotif » que la
     page sait maintenant poser sur le menu Materiau.

     CE QUI PART : le format, la quantite, la matiere, la finition, le
     laminage et le support. La finition et le laminage n ont pas de champ
     sur le formulaire — ils partent dans la description, ou l atelier les
     lit de toute facon.
     ===================================================================== */
  function enMm(po) { return Math.round(po * 25.4); }

  function paquetSoumission(v) {
    var s = S(), e = s && s.etat, c = v.cotes;
    if (!e || !c) return null;
    var q = v.qte || quantite();
    var fmt = nb(c.petit) + ' × ' + nb(c.grand) + ' po (' +
              enMm(c.petit) + ' × ' + enMm(c.grand) + ' mm)';
    var mat = libelle('MATIERES', e.matiere);
    var fin = libelle('FINITIONS', e.finition);
    var lam = libelle('LAMINAGES', e.laminage);

    var L = [];
    L.push('DEMANDE MONTÉE DANS LE CONFIGURATEUR');
    L.push('Configuration sur soumission — ' + q + ' exemplaires.');
    L.push('');
    L.push('   Format : ' + fmt);
    L.push('   Quantité : ' + q);
    if (mat) L.push('   Matériau : ' + mat);
    if (fin) L.push('   Finition : ' + fin);
    if (lam) L.push('   Laminage : ' + lam);
    var support = window.SCDM_SUPPORT_DEMANDE ? window.SCDM_SUPPORT_DEMANDE() : {};
    L.push('   Support : ' + (support.label || supportChoisi() || 'Aucun'));
    L.push('');
    L.push('Dites-nous pour quand vous en avez besoin et joignez votre visuel : ' +
           'on revient avec un prix ferme.');

    return {
      resume: L.join('\n'),
      format: fmt,
      qte: q,
      rigide: support.id && support.id !== 'aucun',
      /* Le menu Materiau de la page de soumission ne connait que du vinyle :
         c est bien ce qu on imprime, le cannele est le SUPPORT. On y pose
         donc la matiere choisie au configurateur. */
      matiereMotif: mat,
      motif: 'Configuration sur soumission : ' + v.motif,
      suite: 'Ajoutez vos coordonnées et votre fichier pour recevoir une soumission. Rien n’est commandé ni payé.',
      liens: []
    };
  }

  function versSoumission(v) {
    var p = paquetSoumission(v);
    if (p) { try { sessionStorage.setItem(CLE_SOUMISSION, JSON.stringify(p)); } catch (e) {} }
    window.location.href = PAGE_SOUMISSION;
  }

  /* Une mesure, dans les deux unites, pour le texte affiche. Elle ne sert
     qu au rendu : le verdict, lui, compare toujours des pouces. */
  function mesure(po) { return nb(po) + ' po (' + enMm(po) + ' mm)'; }

  function texteCannele(v) {
    var traduit = renduLimiteAnglais('corrugated_html', v);
    if (traduit !== null) return traduit;
    var q = v.qte || quantite();
    return '<span class="li-t">Au-delà de ' + CANNELE_QTE_MAX +
      ' exemplaires, on vous fait un prix sur mesure</span>' +
      '<p>Vous en demandez <b>' + q + '</b>. À cette quantité, on regroupe votre ' +
      'travail avec d’autres sur la même feuille et la même passe : <b>le coût ' +
      'baisse</b>, et un prix de grille ne sait pas le calculer.</p>' +
      '<p>Votre configuration — format, quantité, matériau, finition — part avec ' +
      'la demande. Vous n’avez qu’à ajouter vos coordonnées. <b>Réponse sous ' +
      '2 jours ouvrables, prix ferme valide 30 jours.</b></p>' +
      '<p><button type="button" class="li-b" id="scdmLimiteSoumission">' +
      'Demander ma soumission</button></p>';
  }

  function texteRouge(v) {
    if (['grand36','surmesure','route10'].indexOf(v.motif) >= 0) {
      var messages = document.getElementById('scdmRegles2026');
      var text = messages && messages.getAttribute('data-' + v.motif) || '';
      var button = messages && messages.getAttribute('data-button') || '';
      return '<span class="li-t">' + text + '</span><p><button type="button" class="li-b" id="scdmLimiteSoumission">' + button + '</button></p>';
    }
    if (v.motif === 'cannele') return texteCannele(v);
    var traduit = renduLimiteAnglais(v.motif === 'petit' ? 'wide_html' : v.motif === 'grand' ? 'long_html' : 'area_html', v);
    if (traduit !== null) return traduit;
    var c = v.cotes;
    var cause;
    if (v.motif === 'petit') {
      cause = 'Votre pièce fait <b>' + mesure(c.petit) + '</b> sur son plus petit côté, ' +
        'et on imprime jusqu’à <b>52 po (1321 mm)</b> d’un seul morceau. Au-delà, il faut ' +
        'fractionner l’image et raccorder les lés à la pose.';
    } else if (v.motif === 'grand') {
      cause = 'Votre pièce fait <b>' + mesure(c.grand) + '</b> de long, soit plus de ' +
        '<b>20 pieds</b>. À cette longueur, c’est un chantier de pose, pas une ' +
        'commande en ligne.';
    } else {
      cause = 'Votre pièce fait <b>' + nb(c.aire / 144) + ' pi²</b> en vinyle seul. ' +
        'Notre grille de prix s’arrête à 9 pi² sans support rigide : au-delà, ' +
        'un prix automatique serait une extrapolation, pas un vrai prix. ' +
        'Choisissez un <b>support rigide</b> et le prix redevient ferme, ou ' +
        'demandez-nous une soumission.';
    }
    return '<span class="li-t">Cette dimension se fait sur soumission</span>' +
      '<p>' + cause + '</p>' +
      '<p><b>On le fabrique quand même</b> — c’est le prix automatique qui ne ' +
      'convient pas. Écrivez-nous les dimensions et on vous revient avec un ' +
      'prix ferme. <a href="' + PAGE_SOUMISSION + '">Demander une soumission</a></p>';
  }

  function texteJaune(v) {
    var traduit = renduLimiteAnglais('shipping_html', v);
    if (traduit !== null) return traduit;
    return '<span class="li-t">Expédition sur devis</span>' +
      '<p>Votre pièce fait <b>' + mesure(v.cotes.grand) + '</b> de long. Ce format nécessite ' +
      'une validation des possibilités de livraison par notre atelier.</p>' +
      '<p><b>Le prix affiché ci-dessus reste ferme.</b> Seule l’expédition sera ' +
      'confirmée séparément, avant que vous payiez quoi que ce soit. La ' +
      '<b>cueillette à l’atelier d’Alma demeure gratuite</b>.</p>';
  }

  function peindre() {
    if (!boite && !poser()) return;
    var v = verdict();
    etatCourant = v.zone;

    var h = '';
    if (v.zone === 'rouge') h = texteRouge(v);
    else if (v.zone === 'jaune') h = texteJaune(v);

    /* CE QUE LES AUTRES FICHIERS LISENT. scdm-prix-direct.js s en sert pour
       se taire quand « sansPrix » est vrai : au-dela de 25 exemplaires sur
       du cannele, il n y a plus de prix a montrer, et en montrer un quand
       meme serait annoncer un prix qu on ne veut pas honorer. En lecture
       seule — personne n ecrit la-dedans. */
    window.SCDM_LIMITES = {
      zone: v.zone, motif: v.motif || '', sansPrix: !!v.sansPrix,
      msg: v.sansPrix ? texteLimite('volume_quote', 'Ce volume se chiffre sur mesure.') : ''
    };

    if (h !== dernierRendu) {
      dernierRendu = h;
      boite.innerHTML = h;
      boite.className = 'scdm-limite' + (v.zone === 'vert' ? '' : ' ' + v.zone) +
                        (v.motif === 'cannele' ? ' offre' : '');
      boite.hidden = !h;
    }

    var b = document.getElementById('scdmAjouter');
    if (b) {
      var bloque = (v.zone === 'rouge');
      b.classList.toggle('scdm-hors-limite', bloque);
      if (bloque) b.setAttribute('aria-disabled', 'true');
      else if (b.getAttribute('aria-disabled') === 'true') b.removeAttribute('aria-disabled');
    }
  }

  /* ------------------------------------------------------------- LE BLOCAGE */

  function accrocher() {
    /* LE BOUTON DE L OFFRE. Delegue sur le document parce que la boite est
       reecrite a chaque changement de verdict : un ecouteur pose sur le
       bouton lui-meme mourrait au premier redessin. */
    document.addEventListener('click', function (e) {
      var b = (e.target && e.target.closest) ? e.target.closest('#scdmLimiteSoumission') : null;
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var v = verdict();
      if (v.zone !== 'rouge') return;
      b.disabled = true;
      b.textContent = texteLimite('one_moment', 'Un instant…');
      versSoumission(v);
    }, true);

    /* EN CAPTURE SUR LE DOCUMENT : on passe avant l ecouteur de scdm.js et
       avant celui de scdm-panneau.js, qui sont poses sur le bouton lui-meme.
       C est la seule facon d empecher l ajout sans toucher a leur code. */
    document.addEventListener('click', function (e) {
      var b = (e.target && e.target.closest) ? e.target.closest('#scdmAjouter') : null;
      if (!b) return;
      peindre();
      if (etatCourant !== 'rouge') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (boite) {
        boite.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, true);

    /* La mention d expedition part sur la commande. En bulle, APRES que
       scdm.js a empile le design : on retouche le dernier. */
    document.addEventListener('click', function (e) {
      var b = (e.target && e.target.closest) ? e.target.closest('#scdmAjouter') : null;
      if (!b || etatCourant !== 'jaune') return;
      var v = verdict();
      setTimeout(function () {
        var liste = (S() && S().commande) || [];
        if (!liste.length) return;
        var d = liste[liste.length - 1];
        d.props = d.props || {};
        d.props['Expédition'] = 'Sur devis — pièce de ' + mesure(v.cotes.grand) +
          ', hors format colis';
      }, 80);
    }, false);
  }

  /* ------------------------------------------------------------- demarrage */

  function demarrer() {
    if (!document.getElementById('scdmConfig')) return;
    style();
    if (!poser()) return;
    accrocher();

    ['input', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(peindre, 0); }, true);
    });

    setInterval(peindre, 400);
    peindre();
  }

  function quandPret(n) {
    if (document.getElementById('scdmAjouter') && window.SCDM && window.SCDM.calcul) {
      return demarrer();
    }
    if ((n || 0) > 100) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
